import * as React from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';
import DayPicker from 'react-day-picker';

import * as ActivityActions from '../../actions/activity';
import * as UserExplorerCreator from '../../creators/userExplorer';
import getActivityMonth from '../../selectors/getActivityMonth';
import getMonthActivityArray from '../../selectors/getMonthActivityArray';
import getFilteredActivityMonthes from '../../selectors/getFilteredActivityMonthes';
import 'react-day-picker/lib/style.css';
import getActivityInitialMonth from '../../selectors/getActivityInitialMonth';
import userExplorerMonths from '../../selectors/userExplorerMonths';
import getFilteredActivityYears from '../../selectors/getFilteredActivityYears';

import State from '../../interfaces/states/State';

import Month from '../../interfaces/Month';
import DatesAnyArray from '../../interfaces/DatesAnyArray';

interface DispatchProps {
  getCurrentMonth: (month: Month) => void;
  getCurrentYear: (year: string) => void;
  userExplorer: (date: Date | moment.Moment) => void;
}

interface OwnProps {
  authIdInputValue: string;
  getActivityMonth: Date[];
  getActivityInitialMonth: Date;
  getMonthActivityArray: number[];
  getFilteredActivityMonthes: number[];
  userExplorerMonths: any[];
  getFilteredActivityYears: number[];
  currentMonth: Month;
  currentYear: string | number;
  months: Month[];
  isLoading: boolean;
  activityData: DatesAnyArray;
}

interface Props extends DispatchProps, OwnProps {}

function UserExplorerMonthSelect (props: Props) {

  const [isCalendar, setIsCalendar] = React.useState(false);

  React.useEffect(() => {
    if (undefined !== props.getFilteredActivityYears && props.getFilteredActivityYears.length) {
      props.getCurrentYear(props.getFilteredActivityYears[0].toString());
    }
  }, []);
 
  const getMonthValue = React.useCallback((month) => {
    props.getCurrentMonth(month);
    setIsCalendar(!isCalendar);
  }, [props.getCurrentMonth, isCalendar]);

  const getYearValue = React.useCallback((e) => {
    return props.getCurrentYear(e.target.value);
  }, [props.getCurrentYear]);

  const handleDayClick = React.useCallback((day, { selected, disabled }) => {
    if (disabled) {
      // Day is disabled, do nothing
      return null;
    }
    if (selected) {
      // Unselect the day if already selected
      props.userExplorer(day);
      return;
    }
  }, [props.userExplorer]);

  const hideCalendar = React.useCallback(() => {
    setIsCalendar(!isCalendar);
  }, []);

  return(
    <div>
      {
        isCalendar ?
          <div className='user-date-container d-flex flex-column align-flex-end justify-center'>
            <DayPicker
              initialMonth={props.getActivityInitialMonth}
              selectedDays={props.getActivityMonth}
              // @ts-ignore
              onDayClick={handleDayClick} />
            <button
              className='primary-outline-button cancel-button'
              onClick={hideCalendar}>{'Cancel'}</button>
          </div>
          :
          <div>
            {
              props.isLoading ?
                null :
                <section className='month-select-container d-flex flex-column align-center'>
                  <div className='years-select-container d-flex justify-around align-center'>
                    <select
                      value={props.currentYear}
                      onChange={getYearValue}
                      className='year-select'>
                      {props.getFilteredActivityYears
                        ? props.getFilteredActivityYears.map((year, key) => {
                          return <option key={key}>{year}</option>;
                        })
                        : null}
                    </select>
                  </div>

                  <div className='month-select d-flex flex-wrap justify-center'>
                    {
                      props.activityData.dates.length > 0
                        ? undefined !== props.userExplorerMonths[0] && props.userExplorerMonths[0].length ?
                          props.userExplorerMonths[0].map((month, key) => {
                            return month.active ? (
                              <input 
                                className='primary-month-select'
                                onClick={() => getMonthValue(month)}
                                type='button'
                                value={month.label}
                                key={key} />
                            ) : (
                              <input 
                                className='primary-month-notselected' 
                                onClick={() => getMonthValue(month)} 
                                type='button' 
                                value={month.label} 
                                key={key} />
                            );
                          }) : null
                        : props.months.map((month, key) => {
                          return (
                            <input
                              disabled
                              className='primary-month-notselected'
                              type='button'
                              value={month.label}
                              key={key} />
                          );
                        })
                    }
                    {
                      props.activityData.dates.length > 0 ?
                        null :
                        <span className='user-explorer-empty'>{'No User Explorer data for selected period'}</span>
                    }
                  </div>
                </section>
            }
          </div>
      }
    </div>
  );
  
}

const mapStateToProps = (state: State) => {
  return {
    authIdInputValue: state.findUser.authIdInputValue,
    getActivityMonth: getActivityMonth(state),
    getActivityInitialMonth: getActivityInitialMonth(state),
    getMonthActivityArray: getMonthActivityArray(state),
    getFilteredActivityMonthes: getFilteredActivityMonthes(state),
    userExplorerMonths: userExplorerMonths(state),
    getFilteredActivityYears: getFilteredActivityYears(state),
    currentMonth: state.activity.currentMonth,
    currentYear: state.activity.currentYear,
    months: state.activity.months,
    isLoading: state.activity.isLoading,
    activityData: state.activity.activityData,
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    getCurrentMonth: dispatchProps.getCurrentMonth,
    getCurrentYear: dispatchProps.getCurrentYear,
    userExplorer: dispatchProps.userExplorer,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    getCurrentMonth: ActivityActions.fetchActivityMonth,
    getCurrentYear: ActivityActions.fetchActivityYear,
    userExplorer: UserExplorerCreator.userExplorer,
  }, mergeProps
)(React.memo(UserExplorerMonthSelect));
